
export default function ({ store, route }) {
  if (route && route.name && /^products/.test(route.name)) {
    store.dispatch('page/update', { name: 'loadingProductsPage', data: true })
  }

  return Promise.resolve()
}
